import Head from "expo-router/head";
import { Text, View } from "react-native";

export default function HealthRoute() {
	const timestamp = new Date().toUTCString();

	return (
		<>
			<Head>
				<title>Healthcheck</title>
				<meta name="robots" content="noindex" />
			</Head>
			<View className="flex-1 items-center justify-center bg-gray-50 px-6">
				<View className="w-full max-w-sm gap-6 rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
					<View className="gap-1">
						<Text className="font-semibold text-gray-400 text-xs uppercase tracking-widest">
							System Status
						</Text>
						<Text className="font-bold text-2xl text-gray-900">
							Health Check
						</Text>
					</View>

					<View className="flex-row items-center gap-3">
						<View className="h-3 w-3 rounded-full bg-emerald-500" />
						<Text className="font-semibold text-base text-emerald-600">
							All systems operational
						</Text>
					</View>

					<View className="h-px bg-gray-100" />

					<View className="gap-3">
						<View className="flex-row justify-between">
							<Text className="text-gray-400 text-sm">Status</Text>
							<Text className="font-medium text-gray-700 text-sm">200 OK</Text>
						</View>
						<View className="flex-row justify-between">
							<Text className="text-gray-400 text-sm">Checked at</Text>
							<Text className="font-medium text-gray-700 text-sm">
								{timestamp}
							</Text>
						</View>
					</View>
				</View>
			</View>
		</>
	);
}
